<template>
  <div class="hbb_technologyBox">
    <h2>
      车型参数
      <span @click="closeClick">×</span>
    </h2>

    <div class="hl-carDetailsBox">
      <table border="0" cellspacing="0" cellpadding="0">
        <tbody v-for="(item, index) in carDetailList" :key="index">
          <tr>
            <td colspan="6" class="hl-parameterTitle">{{ item.GroupName }}</td>
          </tr>
          <tr v-for="(ele, idx) in item.details" :key="idx">
            <td
              v-for="(v, i) in ele"
              :key="i"
              :class="v.ParamName ? 'hl-parameterName' : 'hl-parameterValue'"
            >
              <div v-if="v.ParamName">
                {{ v.ParamName }}
              </div>
              <div v-if="v.ParamValue">
                {{ v.ParamValue }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <h2 style="margin-top: 25px">机油用量/配件参数</h2>
    <table class="hbb_technologyVal">
      <tr v-for="item in AutoPartsConfig" :key="item">
        <td class="left">{{ item.categoryName }}</td>
        <td class="right">
          <div class="title">
            <template v-if="item.paramDictionary_v3.length > 1"
              ><p style="color: #e74c3c; font-weight: 700">
                请前往智配Store APP端查看
              </p>
            </template>
            <template v-else>
              <p v-for="it in item.paramDictionary_v3" :key="it">
                <b v-if="it.key.length > 0">
                  <span></span>
                  {{ it.key }}：
                </b>
                <template v-if="item.viewType == 1" v-for="itd in it.params">
                  <!-- 展示数据 -->
                  <span v-if="itd.is_image">
                    {{ itd.title }}:
                    <img
                      class="imgBox_v2"
                      :src="itd.value"
                      @click="onPreview_singleImage(itd.value)"
                    />
                  </span>
                  <span v-else> {{ itd.title }}:{{ itd.value }} </span>
                </template>
                <template v-if="item.viewType == 2">
                  <!-- 展示文章 -->
                  <el-button
                    type="primary"
                    @click="on_article_click(it.techInstruct)"
                    >查 看</el-button
                  >
                </template>
              </p>
            </template>
          </div>
        </td>
      </tr>
    </table>

    <el-dialog
      title="安装提示"
      :append-to-body="true"
      :visible.sync="operateTipDialogVisible"
      custom-class="dialogHeigh"
      width="30%"
    >
      <template v-if="BasicInfo.length == 0 && articalDetails.length == 0">
        <div style="text-align: center">暂无数据</div></template
      >
      <template v-else>
        <div v-if="BasicInfo.length > 0">
          <h2 style="margin-bottom: 12px">
            <span class="titleTip"></span> 基础信息
          </h2>
          <table class="basicInfoTable">
            <tr v-for="item in BasicInfo" :key="item.key">
              <td>{{ item.Key }}</td>
              <td>{{ item.Value }}</td>
            </tr>
          </table>
        </div>

        <div v-for="item in articalDetails" :key="item.description">
          <h2 style="margin: 10px 0">
            <span class="titleTip"></span> {{ item.description }}
          </h2>
          <div v-for="(pic, index) in item.images" :key="index">
            <img :src="pic.small" alt="" />
          </div>
        </div>
      </template>
    </el-dialog>

    <ZhipeiViewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="previewUrl"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ZhipeiViewer from "../ZhipeiViewer/image-viewer";
export default {
  components: {
    ZhipeiViewer,
  },
  data() {
    return {
      vinCode: "", //VIN码
      carDetailList: [], //车型参数集合
      AutoPartsConfig: [], // 技术参数集合
      showViewer: false, // 查看大图组件是否启动
      previewUrl: [], // 要放大的图片地址
      operateTipDialogVisible: false, //安装提示弹层是否启动
      articalDetails: {}, //文章内容
      BasicInfo: [], //基本信息
    };
  },
  methods: {
    ...mapActions({
      GetAutoPartsConfigAll: "SearchResultModule/GetAutoPartsConfigAll",
      GetTechInstructInfo: "SearchResultModule/GetTechInstructInfo",
    }),
    // 启动技术参数的弹层
    active(autoParamGroups, vinCode) {
      this.vinCode = vinCode;

      autoParamGroups.forEach((item) => {
        item.details = [];
        for (let i = 0; i < item.AutoParamList.length; i += 3) {
          let beforeArray = item.AutoParamList.slice(i, i + 3);
          let afterArray = [];
          beforeArray.forEach((ele) => {
            afterArray.push({
              ParamName: ele.ParamName,
            });
            afterArray.push({
              ParamValue: ele.ParamValue,
            });
          });
          item.details.push(afterArray);
        }
      });
      this.carDetailList = autoParamGroups;

      //技术参数取得一次就可以了, 不用反复取得
      if (this.AutoPartsConfig.length == 0) {
        this.GetAutoPartsConfigAll({
          vinCode: vinCode,
        }).then((res) => {
          this.AutoPartsConfig = res;
        });
      }
    },
    //查看文章
    on_article_click(techInstruct) {
      this.GetTechInstructInfo({
        vinCode: this.vinCode,
        articleType: techInstruct.articleType,
        techInstructId: techInstruct.techInstructId,
        autoTransmission: techInstruct.autoTransmission,
        remarks: techInstruct.remarks,
      }).then((res) => {
        //伪代码,数据传递给弹层，弹层显示
        this.BasicInfo = res.BasicInfo;
        this.articalDetails = res.details;
        this.operateTipDialogVisible = true;
        // console.log(this.articalDetails, "获取的文本数据");
        // console.log(this.BasicInfo, "获取的基本信息");
      });
    },
    //预览单个大图
    onPreview_singleImage(image) {
      this.showViewer = true;
      this.previewUrl = [image];
      console.log(this.previewUrl);
    },
    //预览多个大图
    onPreview(item, index) {
      this.showViewer = true;
      let tempImgList = [...item.images];
      let temp = [];
      for (let i = 0; i < index; i++) {
        temp.push(tempImgList.shift());
      }

      this.previewUrl = tempImgList.concat(temp);
      console.log(this.previewUrl);
    },
    closeViewer() {
      // 点击查看产品大图 销毁
      this.showViewer = false;
    },
    closeClick() {
      // 点击关闭按钮
      this.$emit("closeEvent");
    },
  },
};
</script>

<style scoped>
.basicInfoTable {
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
}
.basicInfoTable td {
  border: 1px solid #cad9ea;
  padding: 7px;
}
.basicInfoTable tr td:first-child {
  background-color: #f6f6f6;
  color: #666;
  width: 30%;
}
.dialogHeigh {
  height: 370px;
  overflow: auto;
}
.titleTip {
  display: inline-block;
  height: 21px;
  width: 18px;
  background-color: #e74c3c;
  vertical-align: bottom;
  border-radius: 0 6px 6px 0;
}
</style>

<style>
.hbb_technologyBox {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.hbb_technologyBox h2 {
  margin-top: 5px;
  line-height: 30px;
  font-weight: normal;
}
.hbb_technologyBox h2 span {
  float: right;
  font-size: 30px;
  color: #bcbcbc;
  cursor: pointer;
}

.hbb_technologyVal {
  display: flex;
  width: 100%;
  border: 1px solid #ddd;
  border-bottom: 0;
  /* margin-top: 10px; */
  flex-direction: column;
}
.hbb_technologyVal tr {
  float: left;
  width: 100%;
  border-bottom: 1px solid #ddd;
  font-size: 13px;
}
.hbb_technologyVal tr td.left {
  width: 150px;
  background: #fafafa;
  padding: 10px;
}
.hbb_technologyVal tr td.right {
  width: calc(100% - 150px);
  padding: 10px;
}
.hbb_technologyVal tr td.right .imgBox {
  width: 30px;
  height: 30px;
  background: #e74c3c;
  float: left;
  margin-right: 10px;
  cursor: pointer;
}
hbb_technologyVal tr td.right .imgBox img {
  width: 100%;
  height: 100%;
}
.hbb_technologyVal tr td.right .title {
  float: left;
  width: 100%;
  margin-bottom: 10px;
}
.hbb_technologyVal tr td.right .title p {
  float: left;
  margin-top: 5px;
  width: 100%;
  line-height: 17px;
}
.hbb_technologyVal tr td.right .title p span {
  float: left;
  width: auto;
  margin-right: 10px;
}
.hbb_technologyVal tr td.right .title b {
  float: left;
  color: #e74c3c;
  font-size: 13px;
}
.hbb_technologyVal tr td.right .title b span {
  width: 3px;
  height: 15px;
  background: #e74c3c;
  border-radius: 5px;
  margin-top: 1px;
  margin-right: 4px;
}

.hl-carDetailsBox {
  width: 100%;
  height: auto;
  border-top: 1px solid #d8d8d8;
  border-left: 1px solid #d8d8d8;
  float: left;
  clear: left;
}
.hl-carDetailsBox table {
  width: 100%;
  float: left;
  clear: left;
}

.hl-carDetailsBox table td {
  font-size: 14px;
  line-height: 40px;
  text-align: left;
  padding-left: 18px;
  border-right: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
}
.hl-carDetailsBox table td.hl-parameterTitle {
  background: #fafafa;
  font-size: 13px;
  color: #c93533;
}

.hl-carDetailsBox table td.hl-parameterName {
  width: 12.8%;
  color: #5b5b5b;
}
.hl-carDetailsBox table td.hl-parameterValue {
  width: 20.5333333%;
  color: #181818;
}
.hbb_technologyVal tr td.right .imgBox_v2 {
  width: 20px;
  /* height: 30px; */
  /* background: #e74c3c;
  float: left;
  margin-right: 10px; */
  vertical-align: middle;
  cursor: pointer;
}
.hbb_technologyVal tr .el-button {
  padding: 0px 13px 0px 20px;
}
</style>